import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import { exchangeSession } from "@/lib/auth";

/** Handles {redirect}#session_id=... after Emergent Google sign-in. */
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const user = await exchangeSession(sessionId);
        window.history.replaceState(null, "", location.pathname);
        navigate("/admin", { replace: true, state: { user } });
      } catch {
        window.history.replaceState(null, "", location.pathname);
        navigate("/admin", { replace: true, state: { authError: true } });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian-900" data-testid="auth-callback">
      <Logo size={56} />
    </div>
  );
}
